// src/lib/slugs.js
export const slugMap = {
    // Core
    home: { en: '/', es: '/' },
  
    // Top-level
    // products: { en: '/products', es: '/productos' },
    // hf_group: { en: '/hf-group', es: '/hf-group' },
  
    // HF Spain Pages
    who_we_are: { en: '/who-we-are', es: '/quienes-somos' },
    management: { en: '/management', es: '/direccion-hansa-flex' },
    certificates: { en: '/certificates', es: '/certificados-calidad-hidraulica' },
    careers: { en: '/careers', es: '/trabaja-con-nosotros' },
    current_vacancies: { en: '/current-vacancies', es: '/vacantes-actuales' },
    contact_us: { en: '/contact-us', es: '/contacto' },
    contact: { en: '/contact', es: '/contacto-hidraulica-industrial' }, // rename if you really need both routes
    terms_and_conditions: { en: '/terms-and-conditions', es: '/terminos-y-condiciones' },
    // HF Group Pages
    hf_group_management: { en: '/hf-group-management', es: '/direccion-grupo-hansa-flex' },
    hf_group_certificates: { en: '/hf-group-certificates', es: '/certificados-grupo-hansa-flex' },
    hf_group_history: { en: '/hf-group-history', es: '/historia-grupo-hansa-flex' },
    hf_group_mission: { en: '/hf-group-mission-statement', es: '/mision-grupo-hansa-flex' },
    hf_60_years: { en: '/hf-60-years-of-hansa-flex', es: '/60-anos-hansa-flex' },
    annual_report: { en: '/annual-report', es: '/informe-anual' },
    associations: { en: '/associations', es: '/asociaciones-sector-hidraulico' },
    responsibility_social: {
      en: '/responsibility-and-social-commitments',
      es: '/responsabilidad-social-corporativa',
    },
    donation_instead_gifts: { en: '/donation-instead-gifts', es: '/donaciones-en-lugar-de-regalos' },
    diversity: { en: '/diversity', es: '/diversidad' },
  
    // Campaigns — same slug in both languages. The landing page is Spanish-only
    // and its URL is printed on InnoTrans 2026 material, so it must not vary.
    innotrans2026: { en: '/innotrans2026', es: '/innotrans2026' },

    // News & events
    blogs: { en: '/blogs', es: '/blogs' },
    blog_pedido_urgente: { en: '/success-stories/moldtech-hydraulic-solutions-for-industry', es: '/casos-de-exito/moldtech-soluciones-hidraulicas-industria' },
    // Legal
    privacy_policy: {
      en: '/hansa-flex-spain-privacy-policy',
      es: '/politica-de-privacidad-hansa-flex-espana',
    },
    legal_notice: {
      en: '/hansa-flex-spain-legal-notice',
      es: '/aviso-legal-hansa-flex-espana',
    },
    general_conditions: {
      en: '/hansa-flex-spain-general-conditions-of-contracting',
      es: '/condiciones-generales-de-contratacion-hansa-flex-espana',
    },


    // Industrial sectors
    railway: { en: '/railway', es: '/soluciones-hidraulicas-ferroviarias' },
  
    // Products: Hoses & hose lines
    hoses_and_hose_lines: { en: '/hoses-and-hose-lines', es: '/mangueras-y-lineas-hidraulicas'},
    hose_line_config: { en: '/hose-line-config', es: '/configurador-de-mangueras-hidraulicas' },
    hydraulic_hoses: { en: '/hydraulic-hoses', es: '/mangueras-hidraulicas' },
    metal_hoses: { en: '/metal-hoses', es: '/mangueras-metalicas' },
    industrial_hoses: { en: '/industrial-hoses', es: '/mangueras-industriales' },
    performed_hoses: { en: '/performed-hoses', es: '/mangueras-conformadas' },
    ext_high_pfm_hoses: { en: '/ext-high-pfm-hoses', es: '/mangueras-alta-presion' },
    ptfe_hoses: { en: '/ptfe-hoses', es: '/mangueras-ptfe' },
    hose_accessories: { en: '/hose-accessories', es: '/accesorios-de-mangueras'},
  
    // Products: drive/control
    drive_and_control: { en: '/drive-and-control-tech', es: '/sistemas-de-mando-hidraulico' },
    pumps: { en: '/pumps', es: '/bombas-hidraulicas' },
    hydraulic_motor: { en: '/hydraulic-motor', es: '/motores-hidraulicos' },
    cylinder: { en: '/cylinder', es: '/cilindros-hidraulicos' },
    switches_sensors: { en: '/switches-and-sensors', es: '/interruptores-y-sensores' },
    valve_tech: { en: '/valve-tech', es: '/valvulas-hidraulicas' },
    pipeline_installation_valve: { en: '/pipeline-installation-valve', es: '/valvulas-de-instalacion' },
    cartridge_valve: { en: '/cartridge-valve', es: '/valvulas-de-cartucho' },
    cetop_valve: { en: '/cetop-valve', es: '/valvulas-cetop' },
    measuring_tech: { en: '/measuring-tech', es: '/instrumentacion-y-medicion-hidraulica' },
    seven_hundred_hydraulics: { en: '/seven-hundred-hydraulics-bar', es: '/hidraulica-700-bar' },
    pressure_accumulators: { en: '/pressure-accumulators', es: '/acumuladores-de-presion' },
  
    // Products: connection technology
    hydraulic_connection_technology: { en: '/hydraulic-connection-technology', es: '/tecnologia-de-conexion-hidraulica' },
    hose_fitting: { en: '/hose-fitting', es: '/racores-de-manguera' },
    pipe_fitting: { en: '/pipe-fitting', es: '/racores-de-tuberia' },
    adapters: { en: '/adapters', es: '/adaptadores-hidraulicos' },
    coupling: { en: '/coupling', es: '/acoplamientos' },
    ball_valves: { en: '/ball-valves', es: '/valvulas-de-bola' },
    flanges: { en: '/flanges', es: '/bridas' },
  
    // Products: other
    sealing_tech: { en: '/sealing-tech', es: '/sellado-y-estanqueidad-hidraulica' },
    filtration: { en: '/filtration', es: '/filtracion-hidraulica' },
    pneumatics: { en: '/pneumatics', es: '/sistemas-neumaticos' },
    technical_information: { en: '/technical-information', es: '/informacion-tecnica' },
    approvals: { en: '/approvals', es: '/homologaciones' },
    catalogues: { en: '/catalogues', es: '/catalogos' },
  
    // Products: pipelines
    pipelines: { en: '/pipelines', es: '/tuberias-hidraulicas' },
    pipebends: { en: '/pipebends', es: '/curvas-de-tuberia' },
    pipeend_processing: { en: '/pipeend-processing', es: '/procesado-de-extremos-de-tuberia' },
    expansion_joints: { en: '/expansionjoints', es: '/juntas-de-expansion' },
  
    // Services
    hose_management: { en: '/hose-management', es: '/gestion-de-mangueras' },
    mobile_rapid_service: { en: '/mobile-rapid-hydraulic-service', es: '/servicio-hidraulico-movil-rapido' },
    hydraulic_academy: { en: '/hydraulic-academy', es: '/academia-hidraulica' },
    fluid_service: { en: '/fluid-service', es: '/gestion-de-fluidos' },
    oil_analysis: { en: '/oil-analysis', es: '/analisis-de-aceite' },
    oil_filtering_cleaning: { en: '/oil-filtering-and-cleaning', es: '/filtrado-y-limpieza-de-aceite' },
  
    assembly_installation: { en: '/assembly-and-installation', es: '/montaje-e-instalacion' },
    modernisation_optimisation: { en: '/modernisation-and-optimisation', es: '/modernizacion-y-optimizacion-hidraulica' },
    plant_project_planning: {
      en: '/plant-project-planning-and-management',
      es: '/gestion-de-proyectos-hidraulicos',
    },
    installation_of_pipe_hoseline: {
      en: '/installation-of-pipe-and-hoseline-systems',
      es: '/instalacion-de-tuberias-y-lineas',
    },
  
    preventative_maintainance: { en: '/preventative-maintainance', es: '/mantenimiento-preventivo' },
    service_packages: { en: '/service-packages', es: '/paquetes-de-servicio' },
    xcode: { en: '/x-code-hose-identification-system', es: '/x-code-identificacion-de-mangueras' },
    xcode_manager: { en: '/x-code-manager', es: '/x-code-gestor-mangueras' },
    licenses: { en: '/licenses', es: '/licencias' },
    inspection: { en: '/inspection', es: '/servicios-de-inspeccion' },
    industrial_hose_inspection: { en: '/industrial-hose-inspection', es: '/inspeccion-de-mangueras-industriales' },
    dguv_inspection: { en: '/dguv-inspection', es: '/inspeccion-reglamentaria-mangueras' },
    lifting_platforms_loading_bridges: {
      en: '/lifting-platforms-and-loading-bridges',
      es: '/plataformas-elevadoras-y-puentes-de-carga',
    },
  
    repair_and_overhaul: { en: '/repair-and-overhaul', es: '/reparacion-y-revision' },
    hydraulic_cylinder_repair: { en: '/hydraulic-cyclinder-repair', es: '/reparacion-de-cilindros-hidraulicos' },
    pressure_accumulators_systems: {
      en: '/pressure-accumulators-and-associated-systems',
      es: '/acumuladores-y-sistemas-asociados',
    },
  
    // These were mixed-case in current routes; normalize to lowercase for new slugs
    digital_services: { en: '/digitalservices', es: '/servicios-digitales' },
    edi_bmecat: { en: '/edi-bmecat', es: '/edi-y-bmecat' },
    scanner_solutions: { en: '/scanner-solutions', es: '/soluciones-escaner' },
    production: { en: '/production', es: '/produccion-hidraulica-a-medida' },
    customised_assembly: { en: '/customised-assembly', es: '/montaje-personalizado-hidraulico' },
    series_production: { en: '/series-production', es: '/produccion-en-serie-de-mangueras' },
  
    logistics_solutions: { en: '/logistics-solutions', es: '/soluciones-logisticas-hidraulicas'},
    warehouse_management: { en: '/warehouse-management', es: '/gestion-de-almacen' },
    kanban_delivery: { en: '/kanban-delivery', es: '/entrega-kanban' },
    kitting: { en: '/kitting', es: '/kitting-industrial' },
    hydraulic_workshop_containers: { en: '/hydraulic-workshop-containers', es: '/talleres-hidraulicos-moviles' },
    works_in_works: { en: '/works-in-works', es: '/servicios-en-planta' },
  
    engineering: { en: '/engineering', es: '/ingenieria-hidraulica' },
    engineered_by_hansa_flex: { en: '/engineered-by-hansa-flex', es: '/desarrollado-por-hansa-flex' },
    hydraulic_unit: { en: '/hydraulic-unit', es: '/unidades-hidraulicas' },
    prototype_manufacture: { en: '/prototype-manufacture', es: '/fabricacion-de-prototipos' },
    pressure_accumulator_inspection: { en: '/pressure-accumulator-inspection', es: '/inspeccion-de-acumuladores' },
  }
  
  export function getLocalizedSlug(key, lng = 'en') {
    const lang = (lng || 'en').substring(0, 2)
    const mapping = slugMap[key]
    if (!mapping) return '/'
    return mapping[lang] || mapping.en
  }
  
  export function rewritePathForLanguage(currentPath, targetLng) {
    const lang = (targetLng || 'en').substring(0, 2)
    const path = currentPath.startsWith('/') ? currentPath : `/${currentPath}`

    // The slug table stores paths without a trailing slash ('/railway'), but
    // the browser's location often has one: the prerendered pages are real
    // directories, so Apache's DirectorySlash redirects /en/railway to
    // /en/railway/. Comparing the two directly fails, no mapping is found,
    // and the untranslated slug is carried into the other language - giving
    // /es/railway, which 404s. Normalise before matching.
    const normalised = path.length > 1 ? path.replace(/\/+$/, '') : path

    for (const [key, langs] of Object.entries(slugMap)) {
      const matchesAny = Object.values(langs).some((slug) => slug === normalised)
      if (matchesAny) return getLocalizedSlug(key, lang)
    }

    return normalised
  }